<template>
	<div class="case-result">
		<div class="case-result-cont">
			<div class="case-result-text">
				<div class="header5">Case</div>
				<div class="header3">Result</div>
				<div class="paragraph mobile-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
				<div class="paragraph desktop-text">
					Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
					voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.
				</div>
			</div>
			<div class="case-result-cards">
				<AccountInfo />
				<CaseStatusBox />
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import AccountInfo from "@/components/account/AccountInfo.vue";
import CaseStatusBox from "@/components/case/CaseStatusBox.vue";

export default {
	name: "case-result",
	title: "Case Result",
	components: {
		AccountInfo,
		CaseStatusBox,
	},
};
</script>

<style scoped lang="scss">
.case-result {
	padding-bottom: 5vw;
	.mobile-text {
		display: none;
	}
	.desktop-text {
		display: block;
	}
	.header5 {
		color: var(--accent);
		padding-bottom: 10px;
	}
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--white);
	}
	.case-result-cont {
		background: var(--dark-blue);
		text-align: left;
		padding-bottom: 0;
		height: 550px;
		padding: 0 60px;
		padding-top: 120px;
		margin-bottom: 140px;
		display: flex;
		.paragraph {
			color: var(--white);
			opacity: 0.5;
		}
	}
	.case-result-text {
		width: 450px;
		.paragraph.desktop-text {
			margin-top: 35px;
		}
	}
	.case-result-cards {
		padding: 0 5vw;
		// margin-top: -295px;
		width: 390px;
		.header5 {
			color: var(--accent);
			font-size: 34px;
			margin-bottom: 35px;
		}
		.header3 {
			color: var(--white);
		}
	}
	.case-result-cards > div {
		margin-bottom: 26px;
	}
	.button {
		margin: 0 10px;
	}
}
@media screen and (max-width: 414px) {
	.case-result {
		background: var(--white);
		height: 100%;
		padding-bottom: 5vw;
		width: 100%;
		.mobile-text {
			display: block;
		}
		.desktop-text {
			display: none;
		}
		.case-result-cont {
			background: unset;
			padding: unset;
			height: unset;
			display: block;
			.paragraph {
				color: var(--white);
				opacity: 0.5;
			}
		}
		.case-result-text {
			width: unset;
			background: var(--dark-blue);
			height: 460px;
			padding: 47px 16px;
			.paragraph.mobile-text {
				margin-top: 25px;
				margin-bottom: 30px;
			}
		}
		.case-result-cards {
			width: unset;
			padding: 0 5vw;
			margin-top: -295px;
		}
		.case-result-cards > div {
			margin-bottom: 26px;
		}
		.button {
			margin: 0 10px;
		}
	}
}
</style>
